import {HcPair} from './hcpair';
import {Consmin} from './consmin';

export class Broderkort {
    id: number;
    number: string;
    name: string;
    nation: string;
    nation_id: number;
    grad: string;
    grad_id: number;
    juv: string;
    aktuelltdatum: string;
    birthdate: string;
    postort: string;
    adelsnamn: string;
    deltagare: { 'moderloge': HcPair[], 'dotterloge': HcPair[] };
    logetecken: HcPair[];
    permanenta_medaljer: HcPair[];
    husordnar: HcPair[];
    stella: HcPair[];
    tillf_medaljer: HcPair[];
    dotterlogemedaljer: HcPair[];
    felicitas: HcPair[];
    universitetet: HcPair[];
    ambeten: HcPair[];
    hovcharger: HcPair[];
    grader: HcPair[];
    personligavardigheter: HcPair[];
    consmin: Consmin[];
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/models/broderkort.ts